import * as ApiModels from '@/typings/questionnaires-api-models';
import s from './ResponseDebugger.module.scss';

type PdfFill = {
  id: string;
  startIndex: number | null;
  endIndex: number | null;
  expression:
    & Pick<ApiModels.Expression, 'expression'>
    & {
      variables: Array<Pick<ApiModels.ExpressionVariable,
        | 'id'
        | 'variableName'
        | 'selector'
        | 'referenceId'
        | 'referenceType'
      >>;
    }
    | null;
  optionMapping: Record<string, string> | null;
  listFieldTemplate: Pick<ApiModels.FieldTemplate, 'id' | 'key' | 'label'> | null;
  pdfFieldTemplate: Pick<ApiModels.PdfFieldTemplate, 'key'>;
  pdfTemplate: Pick<ApiModels.PdfTemplate,
    | 'id'
    | 'key'
    | 'referenceType'
    | 'fileName'
    | 'referenceId'
  >;
};

type Props = {
  pdfFill: PdfFill;
};

const PdfFill: React.FC<Props> = ({ pdfFill }) => (
  <div className={s.singleResponseWrapper}>
    <div><strong>Id:</strong> {pdfFill.id}</div>
    <div><strong>PdfTemplate:</strong> {pdfFill.pdfTemplate.fileName}</div>
    <div><strong>PdfFieldTemplateKey:</strong> {pdfFill.pdfFieldTemplate.key}</div>
    <div><strong>StartIndex:</strong> {pdfFill.startIndex ?? 'N/A'}</div>
    <div><strong>EndIndex:</strong> {pdfFill.endIndex ?? 'N/A'}</div>
  </div>
);

export default PdfFill;